// Ticket / comment attachments: PDF, Word and PNG/JPG, 10 MB each, up to 5 per ticket.
export const MAX_ATTACHMENT_BYTES = 10 * 1024 * 1024;
export const MAX_TICKET_ATTACHMENTS = 5;
export const ATTACHMENT_ACCEPT = ".pdf,.doc,.docx,.png,.jpg,.jpeg";
export const ATTACHMENT_HINT = "PDF, Word, PNG or JPG — up to 10 MB each";

const EXT = [".pdf", ".doc", ".docx", ".png", ".jpg", ".jpeg"];

/** Returns an error message, or null when the file is acceptable. */
export function validateAttachment(file: { name: string; size: number }): string | null {
  const name = file.name.toLowerCase();
  if (!EXT.some((e) => name.endsWith(e))) return `${file.name}: only PDF, Word (.doc, .docx) and PNG/JPG files are allowed`;
  if (file.size > MAX_ATTACHMENT_BYTES) return `${file.name}: files must be 10 MB or smaller`;
  return null;
}

export function formatBytes(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${Math.round(bytes / 1024)} KB`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}
